import { useMutation, UseMutationResult } from 'react-query';
import api from '../../utils/api/api';
import { API_PASSWORD_RESET } from '../../utils/api/constants';

export const usePasswordReset = (): UseMutationResult<void, Error, string, unknown> => {
  return useMutation<void, Error, string>((email: string) => api.post(API_PASSWORD_RESET, { email }).then(res => res.data));
};
